import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MaterialDesignModule } from 'src/external-modules/material-design.module';

import { CerAuthorizeInterceptor } from './interceptors/cer-authorize.interceptor';

import { IdentityValidationMessagesComponent } from './account/validation-messages/validation-messages.component';
import { LoginComponent } from './account/login/login.component';
import { RegisterComponent } from './account/register/register.component';
import { ConfirmEmailComponent } from './account/confirm-email/confirm-email.component';
import { SendEmailComponent } from './account/send-email/send-email.component';
import { ResetPasswordComponent } from './account/reset-password/reset-password.component';
import { RegisterWithThirdPartyComponent } from './account/register-with-third-party/register-with-third-party.component';

import { CerLoginComponent } from './login/cer-login.component';
import { CerLoginMenuComponent } from './menu/cer-login-menu.component';
import { CerLogoffComponent } from './logoff/cer-logoff.component';

const routes: Routes = [
  {
    path: 'account',
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'register', component: RegisterComponent },
      { path: 'confirm-email', component: ConfirmEmailComponent },
      { path: 'send-email/:mode', component: SendEmailComponent },
      { path: 'reset-password', component: ResetPasswordComponent },
      { path: 'register/third-party/:provider', component: RegisterWithThirdPartyComponent }
    ]
  },
  {
    path: 'authentication',
    children: [ 
     { path: 'login', component: CerLoginComponent },
     { path: 'logoff', component: CerLogoffComponent }
    ]
  }
]

@NgModule({
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: CerAuthorizeInterceptor, multi: true },
    //{provide: HTTP_INTERCEPTORS, useClass: CerLoadingInterceptor, multi: true}
  ],
  declarations: [
    CerLoginMenuComponent,
    CerLoginComponent,
    CerLogoffComponent,
    LoginComponent,
    RegisterComponent,
    ConfirmEmailComponent,
    SendEmailComponent,
    ResetPasswordComponent,
    RegisterWithThirdPartyComponent,
    IdentityValidationMessagesComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    RouterModule.forChild(routes),
    MaterialDesignModule
  ],
  exports: [
    CerLoginMenuComponent
  ]
})
export class CerAuthorizeModule { }



